function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["clearable", "onClear", "InputProps", "sx", "slots", "slotProps"],
    _excluded2 = ["ownerState"];
import * as React from 'react';
import useSlotProps from '@mui/utils/useSlotProps';
import MuiIconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import { ClearIcon } from '../icons';
import { usePickersTranslations } from './usePickersTranslations';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var useClearableField = function useClearableField(props) {
  var _slots$clearButton, _slots$clearIcon;

  var translations = usePickersTranslations();

  var clearable = props.clearable,
      onClear = props.onClear,
      InputProps = props.InputProps,
      sx = props.sx,
      slots = props.slots,
      slotProps = props.slotProps,
      other = _objectWithoutPropertiesLoose(props, _excluded);

  var IconButton = (_slots$clearButton = slots === null || slots === void 0 ? void 0 : slots.clearButton) !== null && _slots$clearButton !== void 0 ? _slots$clearButton : MuiIconButton; // The spread is here to avoid this bug mui/material-ui#34056

  var _useSlotProps = useSlotProps({
    elementType: IconButton,
    externalSlotProps: slotProps === null || slotProps === void 0 ? void 0 : slotProps.clearButton,
    ownerState: {},
    className: 'clearButton',
    additionalProps: {
      title: translations.fieldClearLabel
    }
  }),
      iconButtonProps = _objectWithoutPropertiesLoose(_useSlotProps, _excluded2);

  var EndClearIcon = (_slots$clearIcon = slots === null || slots === void 0 ? void 0 : slots.clearIcon) !== null && _slots$clearIcon !== void 0 ? _slots$clearIcon : ClearIcon;
  var endClearIconProps = useSlotProps({
    elementType: EndClearIcon,
    externalSlotProps: slotProps === null || slotProps === void 0 ? void 0 : slotProps.clearIcon,
    ownerState: {}
  });
  return _extends({}, other, {
    InputProps: _extends({}, InputProps, {
      endAdornment: /*#__PURE__*/_jsxs(React.Fragment, {
        children: [clearable && /*#__PURE__*/_jsx(InputAdornment, {
          position: "end",
          sx: {
            marginRight: InputProps !== null && InputProps !== void 0 && InputProps.endAdornment ? -1 : -1.5
          },
          children: /*#__PURE__*/_jsx(IconButton, _extends({}, iconButtonProps, {
            onClick: onClear,
            children: /*#__PURE__*/_jsx(EndClearIcon, _extends({
              fontSize: "small"
            }, endClearIconProps))
          }))
        }), InputProps === null || InputProps === void 0 ? void 0 : InputProps.endAdornment]
      })
    }),
    sx: [{
      '& .clearButton': {
        opacity: 1
      },
      '@media (pointer: fine)': {
        '& .clearButton': {
          opacity: 0
        },
        '&:hover, &:focus-within': {
          '.clearButton': {
            opacity: 1
          }
        }
      }
    }].concat(_toConsumableArray(Array.isArray(sx) ? sx : [sx]))
  });
};